import React from 'react';

interface Props {
  children: React.ReactNode;
}

export default function TableBody({ children }: Props): JSX.Element {
  return <tbody className="app-table__body">{children}</tbody>;
}
